<template>
  <div>
    <van-nav-bar title="考勤视图" left-text="" right-text="" @click-right=""/>
    <div style="text-align: center">
      <van-tag color="#1497db">休息日</van-tag>
      <van-tag color="#29cc40">工作日</van-tag>
      <van-tag color="#ecece9">未来日</van-tag>
    </div>

    <van-calendar
      title="日历"
      :poppable="false"
      :show-confirm="false"
      :style="{ height: '800px' }"
      :formatter="formatter"
      :min-date="minDate" :max-date="maxDate"
    />

  </div>
</template>

<script>

import {isLogin} from "../../../utils/util";

export default {
  name: "AttendanceView",
  data() {
    return {
      active: 1,
      account: '',
      nickname: '',
      options: [],
      dayList: [],
      currentYear: "",
      currentMonth: "",
      currentDay: "",
      time: "",
      currentDate: false,
      abnormalDay: [],
      workday: [],
      resetDay: [],
      dayLists: [],
      currentYears: null,
      currentMonths: null,
      minDate: new Date(),
      maxDate: new Date(),
    };
  },
  mounted() {
    if (!isLogin()) {
      this.$router.push({
        path: "/attenceflow/Error",
        query: {}
      });
    }
    const date = new Date();
    this.currentYear = date.getFullYear();
    this.currentMonth = date.getMonth() + 1;
    this.currentYears = date.getFullYear();
    this.currentMonths = date.getMonth() + 1;
    this.calDay(this.currentYear, this.currentMonth);
  },
  methods: {
    jumpPage: function () {
      this.$router.push({
        path: "/attenceflow/AttenceHome",
        query: {}
      });
    },
    // 考勤结果过滤
    workOverTimeStatusFormatter(row) {
      let formatName = "";
      this.options.forEach((item) => {
        if (row == item.value) {
          formatName = item.name;
        }
      });
      return formatName;
    },
    formatSrc(item) {
      if (item != "") {
        for (var i = 0; i < this.workday.length; i++) {
          if (this.workday[i].workingTime.slice(8, 10) == item) {
            return "班";
          }
        }
        for (var ii = 0; ii < this.resetDay.length; ii++) {
          if (this.resetDay[ii].workingTime.slice(8, 10) == item) {
            return "休";
          }
        }
      }
    },
    calDay: function (year, month) {
      var oDate = new Date();
      //setFullYear(year,month,day) 方法用于设置年份,返回调整过的日期的毫秒表示。
      oDate.setFullYear(year, month - 1, 1);
      oDate.setDate(1); //设置一个月中的第一天
      var oNow = oDate.getDay(); //当前月的第一天是星期几
      var dayNum = 0; //指定月份的天数
      if (
        month == 1 ||
        month == 3 ||
        month == 5 ||
        month == 7 ||
        month == 8 ||
        month == 10 ||
        month == 12
      ) {
        dayNum = 31;
      } else if (month == 4 || month == 6 || month == 9 || month == 11) {
        dayNum = 30;
      } else if (month == 2 && this.isLeaYear(year)) {
        dayNum = 29;
      } else {
        dayNum = 28;
      }
      var SumDayLiNum = 0; //总共的格子数
      var lastNum = (dayNum - (7 - oNow)) % 7; //最后剩余的数
      lastNum = lastNum == 0 ? 0 : 7;
      SumDayLiNum = 7 + parseInt((dayNum - (7 - oNow)) / 7) * 7 + lastNum;
      this.showDayList(dayNum, SumDayLiNum, oNow);
    },
    //判断是否是闰年
    isLeaYear: function (year) {
      if (year % 4 == 0 && year % 100 != 0) {
        return true;
      } else {
        if (year % 400 == 0) {
          return true;
        } else {
          return false;
        }
      }
    },
    //显示当前日历内容
    showDayList: function (dayNum, SumDayLiNum, oNow) {
      this.dayList = [];
      var rows = parseInt(SumDayLiNum / 7);
      var cols = 7;
      for (var i = 0; i < rows; i++) {
        for (var j = 0; j < cols; j++) {
          if (j == cols - 1) {
            this.dayList.push({
              text: "",
              marginRight0: true,
            });
          } else {
            this.dayList.push({
              text: "",
              marginRight0: false,
            });
          }
        }
      }
      for (var z = 1; z <= dayNum; z++) {
        this.dayList[oNow].text = z;
        oNow++;
      }
      this.loadData();
    },
    formatter(day) {
      const month = day.date.getMonth() + 1;
      const date = day.date.getDate();
      const nowDay = new Date().getDate();
      for (const item of this.dayLists) {
        if (date === item.text) {
          if (item.colorone != "正常") {
            day.topInfo = item.colorone;
          }
          if (item.colortwo != "正常") {
            day.bottomInfo = item.colortwo;
          }

          if (item.style == "班" && item.colorone == '外') {
            day.className = 'workday';
          } else if (item.style == "班" && item.colorone == '假') {
            day.className = 'workday1';
          } else if (item.style == "班" && item.colorone == '旷工') {
            day.topInfo = "旷";
            day.className = 'workday2';
          } else if (item.style == "班" && item.colorone == '迟到') {
            day.topInfo = "迟";
            day.className = 'workday3';
          } else if (item.style == "班" && item.colorone == '早退') {
            day.topInfo = "早";
            day.className = 'workday4';
          } else {
            day.className = 'workday';
          }

          if (item.style == "班" && item.colortwo == '外') {
            day.className = 'workday';
          } else if (item.style == "班" && item.colortwo == '假') {
            day.className = 'workday1';
          } else if (item.style == "班" && item.colortwo == '旷工') {
            day.bottomInfo = "旷";
            day.className = 'workday2';
          } else if (item.style == "班" && item.colortwo == '迟到') {
            day.bottomInfo = "迟";
            day.className = 'workday3';
          } else if (item.style == "班" && item.colortwo == '早退') {
            day.bottomInfo = "早";
            day.className = 'workday4';
          } else {
            day.className = 'workday';
          }

          if (item.style == "休") {
            day.className = 'holiday';
          }

          if (item.text > nowDay) {
            day.className = 'future';
          }
          break;
        }
      }

      return day;
    },
    checks() {
      this.dayList.map((item) => {
        item.show = this.currentDay == item.text && this.currentDate;
        item.style = this.formatSrc(item.text);
      });

      setTimeout(() => {
        this.scheduleList = [];
        console.log(this.abnormalDay);
        this.abnormalDay.map((item) => {
          //正则表达式去除所有空格（就系统存在空格数据）
          item.attendanceResult = item.attendanceResult.replace(/\s*/g, "");
          if (item.attendanceResult.length == 3) {
            var one = item.attendanceResult.slice(0, 1);
            var two = item.attendanceResult.slice(2, 3);

            this.dayList.map((item1) => {
              if (item1.text == +item.workingTime.slice(8, 10)) {
                if (this.workOverTimeStatusFormatter(one) == "正常") {
                  item1.checkone = true;
                  item1.colorone = "正常";
                } else if (this.workOverTimeStatusFormatter(one) == "旷工") {
                  item1.checkone = true;
                  item1.colorone = "旷工";
                } else if (this.workOverTimeStatusFormatter(one) == "迟到") {
                  item1.checkone = true;
                  item1.colorone = "迟到";
                } else if (this.workOverTimeStatusFormatter(one) == "早退") {
                  item1.checkone = true;
                  item1.colorone = "早退";
                } else if (
                  this.workOverTimeStatusFormatter(one) == "外出办事"
                ) {
                  item1.checkone = true;
                  item1.colorone = "外";
                } else if (
                  this.workOverTimeStatusFormatter(one) == "加班" ||
                  this.workOverTimeStatusFormatter(one) == "调休"
                ) {
                  item1.checkone = true;
                  item1.colorone = "例外";
                } else if (this.workOverTimeStatusFormatter(one) != "") {
                  item1.checkone = true;
                  item1.colorone = "假";
                }
                if (this.workOverTimeStatusFormatter(two) == "正常") {
                  item1.checktwo = true;
                  item1.colortwo = "正常";
                } else if (this.workOverTimeStatusFormatter(two) == "旷工") {
                  item1.checktwo = true;
                  item1.colortwo = "旷工";
                } else if (this.workOverTimeStatusFormatter(two) == "迟到") {
                  item1.checktwo = true;
                  item1.colortwo = "迟到";
                } else if (this.workOverTimeStatusFormatter(two) == "早退") {
                  item1.checktwo = true;
                  item1.colortwo = "早退";
                } else if (
                  this.workOverTimeStatusFormatter(two) == "外出办事"
                ) {
                  item1.checktwo = true;
                  item1.colortwo = "外";
                } else if (
                  this.workOverTimeStatusFormatter(two) == "加班" ||
                  this.workOverTimeStatusFormatter(two) == "调休"
                ) {
                  item1.checktwo = true;
                  item1.colortwo = "例外";
                } else if (this.workOverTimeStatusFormatter(two) != "") {
                  item1.checktwo = true;
                  item1.colortwo = "假";
                }
              }
            });
          } else if (item.attendanceResult.length == 1) {
            this.dayList.map((item1) => {
              if (item1.text == +item.workingTime.slice(8, 10)) {
                if (
                  this.workOverTimeStatusFormatter(item.attendanceResult) ==
                  "正常"
                ) {
                  item1.checkone = true;
                  item1.colorone = "正常";
                  item1.checktwo = true;
                  item1.colortwo = "正常";
                } else if (
                  this.workOverTimeStatusFormatter(item.attendanceResult) ==
                  "旷工"
                ) {
                  item1.checkone = true;
                  item1.colorone = "旷工";
                  item1.checktwo = true;
                  item1.colortwo = "旷工";
                } else if (
                  this.workOverTimeStatusFormatter(item.attendanceResult) ==
                  "迟到"
                ) {
                  item1.checkone = true;
                  item1.colorone = "迟到";
                  item1.checktwo = true;
                  item1.colortwo = "迟到";
                } else if (
                  this.workOverTimeStatusFormatter(item.attendanceResult) ==
                  "早退"
                ) {
                  item1.checkone = true;
                  item1.colorone = "早退";
                  item1.checktwo = true;
                  item1.colortwo = "早退";
                } else if (
                  this.workOverTimeStatusFormatter(item.attendanceResult) ==
                  "外出办事"
                ) {
                  item1.checkone = true;
                  item1.colorone = "外";
                  item1.checktwo = true;
                  item1.colortwo = "外";
                } else if (
                  this.workOverTimeStatusFormatter(item.attendanceResult) ==
                  "加班" ||
                  this.workOverTimeStatusFormatter(item.attendanceResult) ==
                  "调休"
                ) {
                  item1.checkone = true;
                  item1.colorone = "例外";
                  item1.checktwo = true;
                  item1.colortwo = "例外";
                } else if (
                  this.workOverTimeStatusFormatter(item.attendanceResult) !=
                  "" &&
                  this.workOverTimeStatusFormatter(item.attendanceResult) !=
                  "休假"
                ) {
                  item1.checkone = true;
                  item1.colorone = "假";
                  item1.checktwo = true;
                  item1.colortwo = "假";
                }
              }
            });
          }
        });
        this.dayLists = this.dayList;
        console.log("拼装数据：" + JSON.stringify(this.dayLists));
      }, 100);
    },
    loadData() {
      this.currentDay = new Date().getDate();
      this.currentdate =
        this.currentYear == new Date().getFullYear() &&
        this.currentMonth == new Date().getMonth() + 1;
      if (this.currentMonth < 10) {
        this.currentMonth = `0${this.currentMonth}`;
      }
      this.time = `${this.currentYear}-${this.currentMonth}`;
      this.$fetch("/attence-api/blade-attendance-info/attendanceInfo/resultType", {}).then(
        res => {
          const data = res.data;
          this.options = [];
          data.map((item) => {
            var obj = {
              value: item.dictValue,
              name: item.dictKey,
            };
            this.options.push(obj);
          });
        },
        error => {

        }
      );

      this.$fetch("/attence-api/blade-attendance-info/attendanceInfo/userIndex", {
        month: this.time
      }).then(
        res => {
          const data = res.data;
          this.abnormalDay = data.attendanceInfoList;
          this.workday = data.timeWorkRecord;
          this.resetDay = data.timeWorkRestRecord;
          this.checks();
        },
        error => {

        }
      );
    }
  }
}
</script>

<style scoped>
.van-nav-bar {
  background-color: #2196f3;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}

/deep/ .van-nav-bar__text {
  color: #fff;
}

/deep/ .holiday {
  background: rgba(64, 158, 255, 0.5);
  color: black;
}

/deep/ .workday {
  background: rgba(66, 192, 156, 0.3);
  color: black;
}

/deep/ .workday1 {
  background: rgba(66, 192, 156, 0.3);
  color: black;
}

/deep/ .workday2 {
  background: rgba(66, 192, 156, 0.3);
  color: black;
}

/deep/ .workday3 {
  background: rgba(66, 192, 156, 0.3);
  color: black;
}

/deep/ .workday4 {
  background: rgba(66, 192, 156, 0.3);
  color: black;
}

/deep/ .future {
  background: #ecece9;
  color: black;

}

/deep/ .workday > .van-calendar__top-info {
  color: white;
  background: #29cc40;
  border-radius: 50%;
  width: 25%; /* 或其他固定值 */
  margin: 0 auto;
}

/deep/ .workday1 > .van-calendar__top-info {
  color: white;
  background: #1497db;
  border-radius: 50%;
  width: 25%; /* 或其他固定值 */
  margin: 0 auto;
}

/deep/ .workday2 > .van-calendar__top-info {
  color: white;
  background: #d92710;
  border-radius: 50%;
  width: 25%; /* 或其他固定值 */
  margin: 0 auto;
}

/deep/ .workday3 > .van-calendar__top-info {
  color: white;
  background: #d42179;
  border-radius: 50%;
  width: 25%; /* 或其他固定值 */
  margin: 0 auto;
}


/deep/ .workday4 > .van-calendar__top-info {
  color: white;
  background: #ff963c;
  border-radius: 50%;
  width: 25%; /* 或其他固定值 */
  margin: 0 auto;
}


/deep/ .workday > .van-calendar__bottom-info {
  color: white;
  background: #29cc40;
  border-radius: 50%;
  width: 25%; /* 或其他固定值 */
  margin: 0 auto;
}

/deep/ .workday1 > .van-calendar__bottom-info {
  color: white;
  background: #1497db;
  border-radius: 50%;
  width: 25%; /* 或其他固定值 */
  margin: 0 auto;
}

/deep/ .workday2 > .van-calendar__bottom-info {
  color: white;
  background: #d92710;
  border-radius: 50%;
  width: 25%; /* 或其他固定值 */
  margin: 0 auto;
}

/deep/ .workday3 > .van-calendar__bottom-info {
  color: white;
  background: #d42179;
  border-radius: 50%;
  width: 25%; /* 或其他固定值 */
  margin: 0 auto;
}

/deep/ .workday4 > .van-calendar__bottom-info {
  color: white;
  background: #ff963c;
  border-radius: 50%;
  width: 25%; /* 或其他固定值 */
  margin: 0 auto;
}

/deep/ .van-calendar__selected-day {
  border-radius: 50% !important;
}

.ccolor {
  background: #d92710;
}

.dcolor {
  background: #d42179;
}

.ecolor {
  background: #ff963c;
}
</style>



// WEBPACK FOOTER //
// src/pages/attenceflow/wel/attendance.vue